module.exports = __webpack_public_path__ + "cloud-application.2_pr6Sqw.svg";